import { Dispatch, SetStateAction } from 'react'
import dynamic from 'next/dynamic'

// Should be ssr to make sure that links are visible to users initially
const DesktopMenu = dynamic(
    () => import('@corratech/air-ooka-header/Menu/DesktopMenu/DesktopMenu')
)

const MobileMenu = dynamic(
    () => import('@corratech/air-ooka-header/Menu/MobileMenu/MobileMenu')
)
// @ts-ignore
import { useNavMenu } from './../hooks/use-nav-menu'
import { usePreloadedData } from 'preload'
import { useTranslation } from 'next-i18next'
import { useStoreConfig } from 'config'
import { useDeviceType } from '@components/common/IsMobile/useDeviceType'
type MenuProps = {
    isMobileMenuOpened: boolean
    setIsMobileMenuOpened: Dispatch<SetStateAction<boolean>>
}
export const Menu = ({
    isMobileMenuOpened,
    setIsMobileMenuOpened
}: MenuProps): JSX.Element | null => {
    const { t } = useTranslation('common')
    const config = useStoreConfig()
    const { isTablet, isMobile } = useDeviceType()
    const variables = config.preload.menu?.variables
    const preloadedMenuData = usePreloadedData('menu')
    const { navigation: navigationData } = useNavMenu(
        { ...variables, onlyTopLevel: false },
        {
            initialData: preloadedMenuData,
            revalidateOnMount: true,
            revalidateOnFocus: false
        }
    )

    if (variables?.category_uid && navigationData) {
        if (isMobile || isTablet) {
            return (
                <MobileMenu
                    category={navigationData}
                    isMobileMenuOpened={isMobileMenuOpened}
                    setIsMobileMenuOpened={setIsMobileMenuOpened}
                />
            )
        }
        return <DesktopMenu category={navigationData} key="desktopMenu" />
    }

    return <span>{t('Failed to load navigation menu')}</span>
}
